<template>
  <v-autocomplete
    @input="setEmailCampaign"
    :items="emailCampaigns"
    item-text="name"
    item-value="id"
    :value="email_campaign_id"
    :label="label"
    :error-messages="errorMessages"
    :disable="disabled"
    outlined
    prepend-inner-icon="mdi-bullhorn"
    no-data-text="No Matching Campaigns"
    :filter="campaignSearchFilter"
    return-object
    hide-details="auto"
    dense
    menu-props="rounded"
  ></v-autocomplete>
</template>

<script>
import { EmailCampaignApi } from '@/services'

export default {
  name: 'email-campaign-select',
  props: {
    dealer_id: {
      type: [Number, String],
      required: false,
      default: null
    },
    email_campaign_id: {
      type: [Number, String],
      required: false,
      default: null
    },
    errorMessages: {
      type: Array
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: 'Email Campaigns'
    }
  },
  data () {
    return {
      emailCampaigns: [],
      selectedEmailCampaign: {}
    }
  },
  computed: {
  },
  watch: {
    dealer_id: {
      immediate: true,
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.fetchEmailCampaigns()
        }
      }
    },
    email_campaign_id: function (val) {
      if (val) {
        this.$logger.trace('Email Campaign Select created')
        if (this.email_campaign_id) {
          return this.$store
            .dispatch('EmailCampaignStore/getEmailCampaign', {
              id: this.email_campaign_id
            })
            .then(emCampaign => this.$emit('selected-email-campaign', emCampaign))
            .catch(error => {
              this.$logger.error('Error loading email campaign(s) into email-campaign-select', error.message)
              this.$flash({
                showClose: true,
                message: 'Error Loading Email Campaign(s). Reload to try again',
                type: 'error'
              })
            })
        }
      } else {
        this.setEmailCampaign({})
      }
    }
  },
  mounted: function () {
    // this.fetchEmailCampaigns()
  },
  methods: {
    setEmailCampaign: function (selectedEmailCampaign) {
      this.selectedEmailCampaign = selectedEmailCampaign
      this.$emit('input', selectedEmailCampaign ? selectedEmailCampaign.id : null)
      this.$emit(
        'update:email_campaign_id',
        selectedEmailCampaign ? selectedEmailCampaign.id : null
      )
      this.$emit('selected-email-campaign', selectedEmailCampaign)
    },
    fetchEmailCampaigns: function () {
      if (!this.dealer_id) { return }
      EmailCampaignApi.fetchEmailCampaignsAbbreviated(this.dealer_id)
        .then(resp => {
          this.emailCampaigns = resp.data
        })
        .catch(error => {
          this.$logger.error(error.message)
          this.$flash({
            showClose: true,
            message: 'Error loading Quick Select Email Campaigns',
            type: 'mini'
          })
        })
    },
    campaignSearchFilter: function (item, queryText, itemText) {
      const cid = item.id.toString().toLowerCase()
      const name = item.name.toString().toLowerCase()
      const searchTerm = queryText.toLowerCase()

      return cid.indexOf(searchTerm) > -1 || name.indexOf(searchTerm) > -1
    }
  }
}
</script>
